import React, { cloneElement, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setQuestionRetryAction } from "../../../../redux/answeringQuestions/answeringQuestions";

const ConceptCheckPlayerHider = ( props ) => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const dispatch = useDispatch();
  const setQuestionRetry = payload => { dispatch( setQuestionRetryAction( payload ) ) };

  const hideConceptCheckPlayer = ( runningTime, isFinished ) => {
    setQuestionRetry( {
      isShowConceptCheckPlayer : false,
      conceptCheckRunningTime : runningTime,
      isFinishedConceptCheck : isFinished
    } );
  };

  return cloneElement( props.children || <Fragment />, {
    title : answeringQuestions.temporaryData.stgNm,
    url : answeringQuestions.temporaryData.cncpMeta,
    onHide : hideConceptCheckPlayer
  } );

};

export default ConceptCheckPlayerHider;
